import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["feed", "resumeButton"];
  static values = { maxMessages: Number };

  connect() {
    this._paused = false;
    requestAnimationFrame(() => this._scrollToBottom());

    this._observer = new MutationObserver(() => {
      this._trim();
      if (!this._paused) this._scrollToBottom();
    });
    this._observer.observe(this.feedTarget, { childList: true });

    this._onScroll = this._handleScroll.bind(this);
    this.feedTarget.addEventListener("scroll", this._onScroll);
  }

  disconnect() {
    this._observer?.disconnect();
    this.feedTarget?.removeEventListener("scroll", this._onScroll);
  }

  resume() {
    this._paused = false;
    this.resumeButtonTarget.classList.add("hidden");
    this._scrollToBottom();
  }

  _handleScroll() {
    if (this._atBottom()) {
      if (this._paused) this.resume();
    } else {
      if (!this._paused) {
        this._paused = true;
        this.resumeButtonTarget.classList.remove("hidden");
      }
    }
  }

  // Turbo appends every incoming message and never removes one, so a dashboard
  // left open across a stream grows without bound. Drop the oldest once the
  // feed exceeds the same window the server renders on first paint, which keeps
  // an eight-hour stream costing what a fresh reload costs.
  //
  // Selects .sc-chat-msg rather than walking children: the dashboard feed's
  // first child is the <turbo-cable-stream-source> element, and removing that
  // would silently kill the live connection.
  _trim() {
    const max = this.maxMessagesValue;
    if (!max) return;

    const messages = this.feedTarget.querySelectorAll(".sc-chat-msg");
    for (let i = 0; i < messages.length - max; i++) messages[i].remove();
  }

  _atBottom() {
    const el = this.feedTarget;
    return el.scrollHeight - el.scrollTop - el.clientHeight < 40;
  }

  _scrollToBottom() {
    this.feedTarget.scrollTop = this.feedTarget.scrollHeight;
  }
}
